import { createFileRoute } from "@tanstack/react-router";

import  DepartmentDetailPage  from "../../../components/Departmens/DepartmentPage";


export const Route = createFileRoute("/_layout/department/$deptId")({
    component: DepartmentDetailPage
});
